import React, { useRef } from 'react';
import { X } from 'lucide-react';
import { motion, useInView } from 'framer-motion';
export function OldSolutionsSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section className="py-20 px-4 sm:px-6 bg-[#FAF8F6]" data-id="element-120">
      <div className="max-w-3xl mx-auto text-center" ref={ref} data-id="element-121">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 20
      }} transition={{
        duration: 0.6
      }} className="text-3xl font-bold text-neutral-900 mb-12 font-serif" data-id="element-122">
          Why random advice doesn’t help <br data-id="element-123" />
          <span className="text-neutral-500 text-2xl font-normal" data-id="element-124">
            (even when it’s “good”)
          </span>
        </motion.h2>

        <div className="space-y-8 text-left" data-id="element-125">
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {
          opacity: 0,
          y: 20
        }} transition={{
          duration: 0.6,
          delay: 0.1
        }} className="text-lg text-neutral-700 leading-relaxed" data-id="element-126">
            Most relocation advice fails because it’s missing the one thing you
            actually need: <strong className="text-neutral-900" data-id="element-127">Order.</strong>
          </motion.p>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {
          opacity: 0,
          y: 20
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="text-lg text-neutral-700 leading-relaxed" data-id="element-128">
            It’s a hundred tips with no sequence, no scripts, and no protection
            when things go wrong. It assumes you’re calm, rested, and have the
            mental space to compare options.
          </motion.p>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={isInView ? {
          opacity: 1,
          scale: 1
        } : {
          opacity: 0,
          scale: 0.95
        }} transition={{
          duration: 0.6,
          delay: 0.3
        }} className="bg-[#F5F0EB] p-6 rounded-lg border-l-4 border-neutral-300 my-8" data-id="element-129">
            <p className="text-xl font-serif italic text-neutral-800" data-id="element-130">
              "But you’re not calm. You’re carrying your life in bags. You’re
              trying to get accepted, not get rejected. You’re trying to stay
              safe."
            </p>
          </motion.div>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {
          opacity: 0,
          y: 20
        }} transition={{
          duration: 0.6,
          delay: 0.4
        }} className="text-lg text-neutral-700 leading-relaxed" data-id="element-131">
            So you pick something—anything—and hope it works.
          </motion.p>
        </div>

        <div className="grid sm:grid-cols-2 gap-6 mt-12" data-id="element-132">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {
          opacity: 0,
          y: 30
        }} transition={{
          duration: 0.6,
          delay: 0.5
        }} className="p-6 border border-neutral-100 rounded-lg shadow-sm bg-[#F5F0EB]" data-id="element-133">
            <div className="flex justify-center mb-4" data-id="element-134">
              <div className="bg-neutral-200 p-2 rounded-full" data-id="element-135">
                <X className="h-6 w-6 text-neutral-500" data-id="element-136" />
              </div>
            </div>
            <h3 className="font-bold text-neutral-900 mb-2" data-id="element-137">
              Scattered Content
            </h3>
            <p className="text-neutral-600 text-sm" data-id="element-138">
              Country-specific blogs that are outdated or not in the order you
              need.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {
          opacity: 0,
          y: 30
        }} transition={{
          duration: 0.6,
          delay: 0.6
        }} className="p-6 border border-neutral-100 rounded-lg shadow-sm bg-[#F5F0EB]" data-id="element-139">
            <div className="flex justify-center mb-4" data-id="element-140">
              <div className="bg-neutral-200 p-2 rounded-full" data-id="element-141">
                <X className="h-6 w-6 text-neutral-500" data-id="element-142" />
              </div>
            </div>
            <h3 className="font-bold text-neutral-900 mb-2" data-id="element-143">No Scripts</h3>
            <p className="text-neutral-600 text-sm" data-id="element-144">
              Knowing "what" to do doesn't help when you freeze in a real
              conversation.
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}